import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { useRoutes, Navigate } from 'react-router-dom';
import { ROUTES, PATHS, USER_TYPES } from './constants';
import NotFoundPage from 'render/views/pages/NotFoundPage';
import LoadingComponent from 'render/views/components/LoadingComponent';

const LoginPage = lazy(() => import('render/views/pages/LoginPage'));
const ResetPasswordPage = lazy(() => import('render/views/pages/ResetPasswordPage'));
const ConfirmPartnerPage = lazy(() => import('render/views/pages/ConfirmPartnerPage'));

const Routes = () => {
    const user = useSelector((state) => state.auth.user);
    const userType = user ? user.user.role : USER_TYPES.GUEST;

    // Generate dynamic routes based on access and user type
    const dynamicRoutes = ROUTES.map((route) => {
        const Component = lazy(() => import(`render/views/pages/${route.component}`));
        const isAuthorized = route.access.includes(userType);

        return {
            path: route.path,
            element: (
                <Suspense fallback={<LoadingComponent />}>
                    {isAuthorized || route.guestAccessible ? (
                        <Component />
                    ) : (
                        <Navigate to={userType === USER_TYPES.GUEST ? PATHS.LOGIN : PATHS.HOME} />
                    )}
                </Suspense>
            ),
        };
    });

    // Define static routes
    const staticRoutes = [
        {
            path: PATHS.LOGIN,
            element: (
                <Suspense fallback={<LoadingComponent />}>
                    <LoginPage />
                </Suspense>
            ),
        },
        {
            path: `${PATHS.RESET_PASSWORD}/:partnerId/:confirmationCode`,
            element: (
                <Suspense fallback={<LoadingComponent />}>
                    <ResetPasswordPage />
                </Suspense>
            ),
        },
        {
            path: `${PATHS.CONFIRM_PARTNER}/:partnerId/:confirmationCode`,
            element: (
                <Suspense fallback={<LoadingComponent />}>
                    <ConfirmPartnerPage />
                </Suspense>
            ),
        },
        {
            path: '*',
            element: (
                <Suspense fallback={<LoadingComponent />}>
                    <NotFoundPage />
                </Suspense>
            ),
        },
    ];

    // Combine static and dynamic routes
    const routes = [...staticRoutes, ...dynamicRoutes];

    return useRoutes(routes);
};

export default Routes;
